"use client";
import ThemeRegistry from "@/components/ThemeRegistry/ThemeRegistry";
import DataLayerProvider from "@/components/DataLayerProvider";
import { ClerkProvider } from "@clerk/nextjs";
import React, { Suspense } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePathname } from "next/navigation";
import LoadingPage from "./LoadingPage";
// const inter = Inter({ subsets: ["latin"] });

// export const metadata: Metadata = {
//   title: "Create Next App",
//   description: "Generated by create next app",
// };

type IProps = {
  children: React.ReactNode;
};

export default function AppLayout(props: IProps) {
  const pathname = usePathname();
  const signInUrl = pathname.includes("/apps/shopify/auth")
    ? pathname
    : "/auth/sign-in";
  const signUpUrl = pathname.includes("/apps/shopify/auth")
    ? pathname
    : "/auth/sign-up";

  return (
    <>
      <ThemeRegistry>
        <ClerkProvider
          publishableKey={process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY}
          signInUrl={signInUrl}
          signUpUrl={signUpUrl}
          signInFallbackRedirectUrl="/auth/signed-in"
          signUpFallbackRedirectUrl="/auth/signed-up"
        >
          <Suspense fallback={<LoadingPage />}>
            <DataLayerProvider>{props.children}</DataLayerProvider>
          </Suspense>
        </ClerkProvider>
      </ThemeRegistry>
      <ToastContainer position="bottom-left" />
    </>
  );
}
